export interface LoginAsUserDTO {
    userEmail: string;
    userId?: number;
    userName: string;
    userToken?: string;
}
